<template>
<div>
 <div class="fluid"> 
    <div id="main">
     
     <b-row>
     <b-col sm="12">
     <div id="barratitulo">
      <br/><br/>
      <h1>REQUISIÇÃO DE PEQUENO VALOR</h1>        
     </div>
     </b-col>
     </b-row>
     
     <b-row>
        <b-col>
        <p id="texto">
            A Requisição de Pequeno Valor (RPV) representa uma obrigação a pagar após o trânsito em julgado de decisão judicial.
            <br/>
            <br/>
            O valor máximo da RPV é estabelecido nos termos da <a href="http://www.fazenda.pr.gov.br/Pagina/Requisicao-de-Pequeno-Valor-0" target="_blank">Lei Estadual nº 18.664/2015</a> e atualizado anualmente pelo Estado através de <a href="http://www.fazenda.pr.gov.br/Pagina/Requisicao-de-Pequeno-Valor-0" target="_blank">Resolução da Secretaria de Estado da Fazenda</a>.
            <br/>
            <br/>
            O prazo para pagamento desse tipo de obrigação é de até 60 (sessenta) dias, contados a partir da data da intimação do Procurador no processo judicial sobre a expedição da RPV.
            <br/>
            <br/>
            Em caso de dúvidas, entrar em contato pelo e-mail: rpv@sefa.pr.gov.br
            <br/>
            <br/>
            <br/>
            Informe nº dos autos ou nome do beneficiário ou CPF do beneficiário ou o período do pagamento:<br />
        </p>
        <br/>
        </b-col>
     </b-row>
    
    <b-row class="formulario">
        <b-col sm="12" md="3">
            <label><strong>N° dos Autos:</strong></label>
            <b-input
                v-model="filtros.nrProcesso"                
                v-mask="'#######-##.####.#.##.####'"
                @blur="formataProcesso"
            ></b-input>
            <div>
            <template v-if="$v.filtros.nrProcesso.$error">
                    <p class="text-danger" v-if="!$v.filtros.nrProcesso.validarNumeroProcesso">Número do Processo inválido.</p>
            </template>
            </div>
        </b-col>
        <b-col sm="12" md="3">
            <label><strong>Nome Beneficiário:</strong></label>
            <b-input
                v-model="filtros.nome"
                maxlength="200"
            >
            </b-input>
            <div style="margin-bottom: 45px;">
            <template v-if="$v.filtros.$error">
                    <p class="text-danger" v-if="!$v.filtros.nome.validar">{{mensagem.erro['005']}}    </p>
            </template>            
            </div>
        </b-col>
        <b-col sm="12" md="2">
            <label><strong>CPF/CNPJ do Beneficiário:</strong></label>
            <!-- b-input
                v-model="filtros.documento"
                v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-NN']">
            </b-input -->
			<the-mask 
			  class="form-control" 
			  v-model="filtros.documento" 
			  :mask="['XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-XX']" />
            <div>
            <template v-if="$v.filtros.$error">
                    <p class="text-danger" v-if="!$v.filtros.documento.validar">CPF ou CNPJ inválido.</p>            
            </template>
            </div>
        </b-col>
        <b-col sm="12" md="4">
        <b-row>
            <b-col sm="5">
                <b-form-group class="mb-0">
                    <label for="dataIniFormatada"><strong>Período do Pagamento:</strong></label>
                    <b-input-group>
                        <b-form-input
                        id="dataIniFormatada"
                        v-model="filtros.dataIniFormatada"
                        type="text"
                        placeholder="dd/mm/aaaa"
                        v-mask="'##/##/####'"
                        autocomplete="off"
                        >
                        </b-form-input>

                        <b-input-group-append>
                            <b-form-datepicker
                                v-model="filtros.dataIni"
                                placeholder="dd/mm/aaaa"
                                :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric'}"            
                                labelPrevYear="Ano anterior"
                                labelPrevMonth="Mês anterior"
                                labelNextMonth="Próximo mês"
                                labelNextYear="Próximo ano"
                                labelCurrentMonth="Mês atual"
                                label-no-date-selected=""
                                locale="pt-BR"
                                labelHelp=""
                                aria-controls="dataIniFormatada"
                                button-only
                                @context="mudarDataIniFormatada"
                                hide-header
                                right
                                :min="minDate"
                            >
                            </b-form-datepicker>                            
                        </b-input-group-append>
                    </b-input-group>
                    
                </b-form-group>
                <div>
                <template v-if="$v.filtros.$error">
                        <p class="text-danger" v-if="$v.filtros.dataFimFormatada.$model.length == 10 && $v.filtros.dataIniFormatada.$model.length == 0">{{mensagem.erro['035']}}    </p>
                        <p class="text-danger" v-if="$v.filtros.dataIniFormatada.$model.length == 10 && $v.filtros.dataFimFormatada.validarTamanho && $v.filtros.dataIniFormatada.validarData && $v.filtros.dataIniFormatada.validarTamanho && !$v.filtros.dataIniFormatada.menorQueDataFim">{{mensagem.erro['003']}}    </p>
                        <p class="text-danger" v-if="!$v.filtros.dataIniFormatada.validarData || !$v.filtros.dataIniFormatada.validarTamanho">{{mensagem.erro['001']}}    </p>
                </template>
                </div>
            </b-col>
            <b-col sm="1"><br/><br/>Até</b-col>
            <b-col sm="5">
                <b-form-group class="mb-0">
                    <label for="dataFimFormatada">&nbsp;</label>
                    <b-input-group>
                        <b-form-input
                        id="dataFimFormatada"
                        v-model="filtros.dataFimFormatada"
                        type="text"
                        placeholder="dd/mm/aaaa"
                        v-mask="'##/##/####'"
                        autocomplete="off"
                        >
                        </b-form-input>

                        <b-input-group-append>
                            <b-form-datepicker
                                v-model="filtros.dataFim"
                                placeholder="dd/mm/aaaa"
                                :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric'}"            
                                labelPrevYear="Ano anterior"
                                labelPrevMonth="Mês anterior"
                                labelNextMonth="Próximo mês"
                                labelNextYear="Próximo ano"
                                labelCurrentMonth="Mês atual"
                                label-no-date-selected=""
                                locale="pt-BR"
                                labelHelp=""
                                aria-controls="dataFimFormatada"
                                button-only
                                @context="mudarDataFimFormatada"
                                hide-header
                                right
                                :min="minDate"
                            >
                            </b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>                    
                </b-form-group>
                <div>
                <template v-if="$v.filtros.$error">
                        <p class="text-danger" v-if="!$v.filtros.dataFimFormatada.validarData || !$v.filtros.dataFimFormatada.validarTamanho">{{mensagem.erro['001']}}    </p>
                        <p class="text-danger" v-if="$v.filtros.dataIniFormatada.$model.length == 10 && $v.filtros.dataFimFormatada.validarData && !$v.filtros.dataFimFormatada.diferencaDias">{{mensagem.erro['004']}}    </p>
                </template>
                </div>
            </b-col>
        </b-row>

        </b-col>
    </b-row>        
          
    <b-row>
    <b-col sm="12">
        <b-card-footer>
        <div class="d-flex justify-content-center">
            <b-button href="#" variant="success" class="mx-1 botao" @click="pesquisar">
                Pesquisar
            </b-button>
            <b-button href="#" variant="success" class="ml-1 botao" @click="reset">
                Limpar
            </b-button>
        </div>
        </b-card-footer>      
    </b-col>
    </b-row>

 </div>
</div>
    <template v-if="$v.filtros.$error">
    <b-row class="formulario">
        <b-col sm="12" md="12">
            <p class="text-danger" style="padding-top: 30px; font-size: 16px; text-align: center; font-weight: bold;" v-if="!$v.filtros.formValid.valid">{{mensagem.erro['002']}}</p>
        </b-col>
    </b-row>
    </template>
</div>
</template>

<script>

import moment from 'moment'
import lpad from '@/lib/lpad'
import { formatarNumeroProcesso } from '@/util/formatacaoUtil'
import { mensagemPorCodigo } from '@/util/mensagem'
import servicoProcessoRPV from '@/api/processorpv'
import servicoValidacao from '@/lib/Documentos'
import debug from '@/util/debug'

const fnm = 'transp/_CardFiltrosPesquisa.vue'

export default {
    data() {
        return {
            mensagem: mensagemPorCodigo,
            filtros: this.getFiltros(),
            minDate: moment('2020-01-01').toDate(),
      		maxDate: moment('2100-12-31').toDate()
        }
    },
    methods: {
        getFiltros() {
            debug(null, 'getFiltros', fnm)
            return {
                nrProcesso: '',
                nome: '',
                documento: '',
                dataIni: '',
                dataFim: '',
                dataIniFormatada: '',
                dataFimFormatada: ''
            }
        },
        pesquisar() {
            debug(null, 'pesquisar', fnm)
            this.$v.$touch()
            if(this.$v.$error)
                return;

                this.formataProcesso()

            // Formata objeto do formulário.
            let p = {
                nrProcesso: this.filtros.nrProcesso.replace(/\D+/g, ''),
                nrProcessoFmt: lpad(new String (this.filtros.nrProcesso.replace(/\D+/g, '')), 20, '0'),
                nome: this.filtros.nome,
                documento: this.filtros.documento.replace(/[^a-zA-Z0-9]/g, ''),
                documentoFmt: this.filtros.documento,
                dataIni: this.filtros.dataIni.replace(/\D+/g, ''),
                dataFim: this.filtros.dataFim.replace(/\D+/g, ''),
                dataFimFormatada: this.filtros.dataFimFormatada,
                dataIniFormatada: this.filtros.dataIniFormatada,
            }

            this.$emit('pesquisar', p)
        },
        reset() {
            debug(null, 'reset', fnm)
            this.$v.$reset()
            this.filtros = this.getFiltros()
            this.$emit('reset')
            
        },
        mudarDataIniFormatada(ctx) {
            debug(null, 'mudarDataIniFormatada', fnm)
            if(ctx.selectedYMD)
                this.filtros.dataIniFormatada = ctx.selectedFormatted
        },
        mudarDataFimFormatada(ctx) {
            debug(null, 'mudarDataFimFormatada', fnm)
            if(ctx.selectedYMD)
                this.filtros.dataFimFormatada = ctx.selectedFormatted
        },
        formataProcesso() {
            debug(null, 'formataProcesso', fnm)
            if(this.filtros.nrProcesso.length && this.filtros.nrProcesso.length < 25) {
                this.filtros.nrProcesso = lpad(new String (this.filtros.nrProcesso.replace(/\D+/g, '')), 20, '0')

                this.filtros.nrProcesso = formatarNumeroProcesso(this.filtros.nrProcesso)
            }
        }
    },
    watch: {
        'filtros.dataIniFormatada': function(value) {
            if(!value)
                this.filtros.dataIni = ''
            else if(value.length == 10)
                this.filtros.dataIni = moment(value, "DD/MM/YYYY").format('YYYY-MM-DD')
        },
        'filtros.dataFimFormatada': function(value) {
            if(!value)
                this.filtros.dataFim = ''
            else if(value.length == 10)
                this.filtros.dataFim = moment(value, "DD/MM/YYYY").format('YYYY-MM-DD')
        }
    },
    validations: {
        filtros: {
            nrProcesso: {
                validarNumeroProcesso: (value) => {
                    if(!value)
                        return true
                    
                    return servicoProcessoRPV.validarNumeroProcesso(lpad( value.replace(/\D+/g, ''), 20, '0'))
                    .then((res) => {
                        return Promise.resolve(true)
                    })
                    .catch((res) => {
                        return Promise.reject(false)
                    })

                }
            },
            nome: {
                validar: (value) => (value.length == 0 || value.length > 4)
            },
            documento: {
                validar: (value) => (value.length == 0 || servicoValidacao.ValidaCPF(value) || servicoValidacao.ValidaCNPJ(value))
            },
            dataIniFormatada: {
                validarData: value => (value) ? moment(value, 'DD/MM/YYYY').isValid() : true,
                validarTamanho: (value) => (value.length == 0 || value.length == 10),
                menorQueDataFim: (value, vm) => {                    
                    return (value, vm) ? vm.dataFimFormatada.length == 0 || moment(value, 'DD/MM/YYYY').isBefore(moment(vm.dataFimFormatada, 'DD/MM/YYYY')) || value == vm.dataFimFormatada : true;
                }                
            },
            dataFimFormatada: {
                validarData: value => (value) ? moment(value, 'DD/MM/YYYY').isValid() : true,
                validarTamanho: (value) => (value.length == 0 || value.length == 10),
                diferencaDias: (value, vm) => {
                    return value.length == 0 || moment(value, 'DD/MM/YYYY').diff(moment(vm.dataIniFormatada, 'DD/MM/YYYY'), 'days') <= 60
                }
            },
            formValid: {
                valid: (value, vm) => {
                    return vm.nrProcesso
                           || vm.nome
                           || vm.documento
                           || vm.dataIniFormatada
                           || vm.dataFimFormatada
                }
            }
        }
    }
}
</script>

<style>
#main {
    border: solid 1px;
    border-color: rgba(121, 121, 121, 1);
    background-color: rgba(242, 242, 242, 1);    
}
#barratitulo {
    padding: 10px 10px 10px 10px;
    min-height: 119px;
    border-width: 0px;
    left: 0px;
    top: 0px;
    background: inherit;
    background-color: inherit;
    background-color: rgba(0, 128, 128, 1);
    border: none;
    border-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FFFFFF;
    text-justify: inter-word;
}
#texto, .formulario {
    padding: 10px 10px 10px 10px;
}
h1 {
    font-family:'Arial Negrito', 'Arial Normal', 'Arial';
    font-weight:700;
}
.botao {
    font-family: 'Arial Normal', 'Arial';
    font-weight: bold;
    font-style: normal;
    font-size: 16px;
    letter-spacing: normal;
    text-align: center;
    line-height: normal;
    text-transform: none;
}
label {
 white-space: nowrap;
}
</style>
